export default {
	healthDiagnosis:'健康度诊断',
	totalHealth:'总健康度',
	subComponentHealth:'子部件健康诊断:',
	batteryLifePrediction:'电池寿命预估',
	nodata:'暂无数据'
}


// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/alert.js